import transitionsApi from "../../api/transitionsApi";

const state = { transitions: [] };

const actions = {
    createTransition({ commit }, transition) {
        return new Promise((resolve, reject) => {
            transitionsApi
                .store(transition)
                .then((response) => {
                    if (response.status === 201) {
                        commit("ADD_TRANSITION", response.data.transition);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    ADD_TRANSITION: (state, transition) => state.transitions.unshift(transition),
};
export default { state, actions, mutations };